import { Box } from '@mui/material';
import { Header } from 'components/home';
import { StepperHorizontal } from 'components/shared/stepper_horizontal';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import React, { useEffect, useState } from 'react';
import Step1 from './Step1';
import Step2 from './Step2';
import useCifaStore from 'stores/cifa/cifa.store';
import { ROUTES } from 'routes/constants';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFormik } from 'formik';
import schoolFeedingValidationSchema from './schoolFeeding.validation';

export interface InstitutionI {
  id: number;
  name: string;
}

const SchoolFeeding2026: React.FC = () => {
  const steps = ['Alimentação Escolar', 'Confirmação dos Dados'];
  const [activeStep, setActiveStep] = useState<number>(0);
  const [submittedOnce, setSubmittedOnce] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { cifa } = useCifaStore();

  const formik = useFormik({
    initialValues: {
      alimentacao_af_recurso_pnae: cifa.alimentacao_af_recurso_pnae || 0,
      alimentacao_af_recurso_estado: cifa.alimentacao_af_recurso_estado || 0,
      alimentacao_af_recurso_prefeitura: cifa.alimentacao_af_recurso_prefeitura || 0,
      alimentacao_total_recurso_pnae: cifa.alimentacao_total_recurso_pnae || 0,
      alimentacao_total_recurso_estado: cifa.alimentacao_total_recurso_estado || 0,
      alimentacao_total_recurso_prefeitura: cifa.alimentacao_total_recurso_prefeitura || 0,
      alimentacao_ata_aprovacao_uuid: cifa.alimentacao_ata_aprovacao_uuid || ''
    },
    validationSchema: schoolFeedingValidationSchema,
    onSubmit: (values) => {
      if (activeStep === 0) {
        setActiveStep((prevStep) => prevStep + 1);
      }
      if (activeStep === 1) {
        // Lógica para finalizar ou salvar
        console.log('Formulário finalizado:', values);
      }
    },
    validateOnChange: submittedOnce,
    validateOnBlur: submittedOnce,
  })

  // Extrai o ano da rota, ex: /service_management/cifa-2027 => 2027
  const match = location.pathname.match(/cifa-(\d{4})/);
  const anoReferencia = match ? Number(match[1]) : 2026;

  const handleNext = async () => {
    setSubmittedOnce(true);
    formik.handleSubmit();
  };

  const handleBack = () => setActiveStep((prevStep) => prevStep - 1);

  useEffect(() => {
    if (!cifa.uuid) {
      navigate(ROUTES[`CIFA${anoReferencia}` as keyof typeof ROUTES] as string);
    }
  }, [cifa, navigate, anoReferencia]);

  return (
    <MenuProvider>
      <TopNavBar />
      <Header title={`CIFA - Cadastrar Município - ${anoReferencia}`} showBackButton={true} />
      <Box width='97%' display='flex' flexDirection='column' justifyContent='center' alignItems='center' margin='2rem'>
        <StepperHorizontal activeStep={activeStep} steps={steps} maxWidth='1152px' />
        {activeStep === 0 && (
          <Step1 onNext={handleNext} formik={formik} />
        )}
        {activeStep === 1 && <Step2 formik={formik} onBack={handleBack} />}
      </Box>
    </MenuProvider>
  );
};

export default SchoolFeeding2026;
